import Vue from 'vue'
import App from './App.vue'
// 移动端适配
import 'amfe-flexible'
// VantUI 全局引入
import Vant from 'vant'
import 'vant/lib/index.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import StorageUtil from './utils/storage'
import { setTokenCache } from './utils/request'

Vue.use(Vant)
Vue.use(ElementUI)

Vue.config.productionTip = false

// 异步初始化 token，确保在 APK 环境中能够正确获取 token
async function initToken() {
  try {
    const token = await StorageUtil.getItem('token');
    if (token) {
      setTokenCache(token);
      console.log('Token 初始化成功:', token);
    }
  } catch (error) {
    console.error('Token 初始化失败:', error);
  }
}

// 初始化 token 后再挂载应用
initToken().then(() => {
  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app')
})
